var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"details_content_repeat"},[_c('QS-h4-title',{attrs:{"title":"相关应收信息"}}),_vm._v(" "),_c('QS-common-table',{attrs:{"columns":_setup.payfeeInfoHeader,"data":_setup.payfeeInfoList,"loading":_setup.loading,"pagination":_setup.paginationData},on:{"change":_setup.paginationChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }